import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'currencyConvert' } )
export class CurrencyConvertPipe implements PipeTransform {

    transform( pCurrency: number ): string {
        if (pCurrency != null){
            return pCurrency.toLocaleString('en-IN');
        } else {
            return '0';
        }

    }
}
